export default class DepartmentMeasurementIndexes {
    primaryMeasurementUnit: number;
    predictionMeasurementUnit: number;
    actualInputMeasurementUnit: number;
    calculatedMeasurementUnit: number;
    secondaryCalculatedMeasurementUnit: number;

    constructor(
        primaryMeasurementUnit: number,
        predictionMeasurementUnit: number,
        actualInputMeasurementUnit: number,
        calculatedMeasurementUnit: number,
        secondaryCalculatedMeasurementUnit: number
    ) {
        this.primaryMeasurementUnit = primaryMeasurementUnit;
        this.predictionMeasurementUnit = predictionMeasurementUnit;
        this.actualInputMeasurementUnit = actualInputMeasurementUnit;
        this.calculatedMeasurementUnit = calculatedMeasurementUnit;
        this.secondaryCalculatedMeasurementUnit = secondaryCalculatedMeasurementUnit;
    }
}